<template>
  <div id="app" :class="languageClass">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('app mounted')
  },
  name: 'App',
  computed: {
    languageClass() {
      console.log('dddddddddddd', this.$i18n.locale);
      return this.$i18n.locale === 'en' ? 'en-font' : 'zh-font';
    }
  },
  watch: {
    '$i18n.locale': function (newLocale) {
      // 可以在这里添加其他逻辑，比如重新加载某些资源
      console.log('切换语言', newLocale);
    }
  },
  created() {
    console.log('Initial locale:', this.$i18n.locale);
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.en-font {
  font-family: 'Poppins', sans-serif !important;
}

.zh-font {
  font-family: 'MiSans', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue